import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { RootState } from "app/store";

import { RefObject, useMemo } from "react";
import { RecordingPlaybackDirection } from "../types/RecordingPlaybackDirection";
import { reIdSelectors } from "./store/selectors";
import { BoundingBoxOverlay } from "./BoundingBoxOverlay";
import { reIdActions, reIdThunks } from "./store/slice";

interface ActiveReIdOverlayProps {
    persistedRecordingId: EntityId;
    direction: RecordingPlaybackDirection;
    containerRef: RefObject<HTMLDivElement | null>;
}

export function ActiveReIdOverlay(props: ActiveReIdOverlayProps) {
    const dispatch = useAppDispatch();

    const selectObjectDetectionsByPersistedRecordingIdAndTime = useMemo(
        () =>
            reIdSelectors.selectAllObjectDetectionsByPersistedRecordingIdAndTimeFactory(
                props.direction,
            ),
        [props.direction],
    );

    const detectedObjects =
        useAppSelector((state: RootState) =>
            selectObjectDetectionsByPersistedRecordingIdAndTime(
                state,
                props.persistedRecordingId,
            ),
        ) ?? [];

    return (
        <BoundingBoxOverlay
            detectedObjects={detectedObjects}
            containerRef={props.containerRef}
            onDetectedObjectClick={(detectedObject) => {
                dispatch(reIdThunks.pausePlaybackAndSaveUserPlaybackMode());

                dispatch(
                    reIdActions.setSelectedDetectedObjectFrame(detectedObject),
                );
            }}
        />
    );
}
